/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_BrokersInputs */

const cs_import_stat_brokers = /** @type {(inputs: Import_Stat_BrokersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Makléři: ${i?.count}`)
};

const en_import_stat_brokers = /** @type {(inputs: Import_Stat_BrokersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brokers: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Brokers: {count}" |
*
* @param {Import_Stat_BrokersInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_brokers = /** @type {((inputs: Import_Stat_BrokersInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_BrokersInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_brokers(inputs)
	return cs_import_stat_brokers(inputs)
});